<template>
  <div>
    <FDBannerImg />
    <div class="navigation">
      <div class="page-cen">
        <div class="navigation-item">
          <a href="javascript:void(0)" @click="goPage('/home')">首页</a>
          &nbsp;&gt;
          <a class="active" href="javascript:void(0)">学科资源</a>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="content">
        <!-- 选项卡 -->
        <div class="tabs-header">
          <div class="tab-item" :class="{ active: activeTab === 'department' }"
            @click="changeTab('department')">
            系科资源
          </div>
          <div class="tab-item" :class="{ active: activeTab === 'topic' }" @click="changeTab('topic')">
            专题资源
          </div>
        </div>

        <!-- 系科资源 -->
        <div v-if="activeTab === 'department'">
          <div class="cards-container">
            <div class="card" v-for="(item, index) in departmentList" :key="index"
              @click="toDepartment(item)"
              @mouseenter="hoverDepartmentIndex = index"
              @mouseleave="hoverDepartmentIndex = -1">
              <div class="card-image">
                <img :src="hoverDepartmentIndex === index ? item.selectedImageUrl : item.defaultImageUrl" 
                     :alt="item.resourceName">
              </div>
              <div class="card-content">{{ item.resourceName }}</div>

              <div class="card-heng"></div>
              <div class="card-jia">
                  <img :src="hoverDepartmentIndex === index ? jia_a : jia">
              </div>
            </div>
          </div>
        </div>

        <!-- 专题资源 -->
        <div v-if="activeTab === 'topic'">
          <div class="cards-container">
            <div class="card" v-for="(item, index) in topicList" :key="index" @click="toTopic(item)"
              @mouseenter="hoverTopicIndex = index"
              @mouseleave="hoverTopicIndex = -1">
              <div class="card-image">
                <img :src="hoverTopicIndex === index ? item.selectedImageUrl : item.defaultImageUrl" 
                     :alt="item.resourceName">
              </div>
              <div class="card-content">{{ item.resourceName }}</div>

              <div class="card-heng"></div>
              <div class="card-jia">
                  <img :src="hoverTopicIndex === index ? jia_a : jia">
              </div>
            </div>
          </div>
        </div>

        <div v-if="(activeTab === 'department' && departmentList.length === 0) || 
                   (activeTab === 'topic' && topicList.length === 0)" 
             class="empty">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FDBannerImg from "@c/FDBannerImg";
import { getDepartmentList, getSpecialList } from '@/lzk/api/subjectResource';
import jia from '@/assets/lzk/jia.png';
import jia_a from '@/assets/lzk/jia_a.png';

export default {
  name: "SubjectResource",
  components: { FDBannerImg },
  data() {
    return {
      logo: "",
      copyright: {},
      currentPage: 1,
      pageSize: 10,
      activeTab: "department",
      hoverDepartmentIndex: -1, // 当前悬停的系科索引
      hoverTopicIndex: -1,      // 当前悬停的专题索引
      jia: jia,                // 默认加号图标
      jia_a: jia_a,            // 悬停加号图标
      departmentList: [],       // 存储系科资源数据
      topicList: [],            // 存储专题资源数据
      loading: false            // 加载状态
    };
  },
  created() {
    // 初始加载系科资源
    this.fetchDepartmentData();
  },
  methods: {
    // 切换标签页
    changeTab(tab) {
      if (this.activeTab === tab) return;
      
      this.activeTab = tab;
      if (tab === 'department') {
        if (this.departmentList.length === 0) {
          this.fetchDepartmentData();
        }
      } else {
        if (this.topicList.length === 0) {
          this.fetchTopicData();
        }
      }
    },
    
    // 获取系科资源数据
    async fetchDepartmentData() {
      try {
        this.loading = true;
        const response = await getDepartmentList();
        console.log(response)
        if (response.code === 200) {
          this.departmentList = response.rows;
        } else {
          this.$message.error(response.msg || '获取系科数据失败');
        }
      } catch (error) {
        console.error('获取系科数据出错:', error);
        this.$message.error('获取系科数据出错');
      } finally {
        this.loading = false;
      }
    },
    
    // 获取专题资源数据
    async fetchTopicData() {
      try {
        this.loading = true;
        const response = await getSpecialList();
        if (response.code === 200) {
          this.topicList = response.rows;
        } else {
          this.$message.error(response.msg || '获取专题数据失败');
        }
      } catch (error) {
        console.error('获取专题数据出错:', error);
        this.$message.error('获取专题数据出错');
      } finally {
        this.loading = false;
      }
    },
    
    toDepartment(item) {
      console.log("跳转到系科:", item.resourceName,item);
      // 实际跳转逻辑，可使用item.resourceId
       this.$router.push({ path: `/subjectresources/detail/${1}/${item.resourceId}/${item.resourceName}` });
    },
    
    toTopic(item) {
      console.log("跳转到专题:", item.resourceName);
      // 实际跳转逻辑
      this.$router.push({ path: `/subjectresources/detail/${2}/${item.resourceId}/${item.resourceName}`});
    },
    
    goPage(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style scoped lang="scss">
/* 样式保持不变 */
.banner_img {
  height: 220px;
  overflow: hidden;
  position: relative;
}

.container {
  width: 1200px;
  margin: 20px auto;
  padding-bottom: 96px;
  min-height: 500px;

  .tag {
    display: flex;

    .tag_item {
      cursor: pointer;
      border: 1px solid #cdcdcd;
      background: #fff;
      font-size: 12px;
      color: #525252;
      line-height: 29px;
      padding: 0 18px;
      margin-right: 10px;
      border-radius: 20px;
    }

    .tag_item:hover,
    .active_tag {
      background-color: #004796;
      color: #fff;
    }
  }

  .content {
    padding-top: 10px;

    .empty {
      text-align: center;
    }

    .tabs-header {
      width: 100%;
      display: flex;
      border-bottom: 1px solid #e4e7ed;
      margin-bottom: 30px;

      .tab-item {
        padding: 12px 24px;
        font-size: 16px;
        cursor: pointer;
        position: relative;
        color: #000;
        transition: all 0.3s;
        text-align: center;
        width: 50%;

        &::after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: 3px;
          background-color: #004896;
          border-radius: 2px;
        }

        &.active {
          color: #fff;
          font-weight: 600;
          height: 100%;
          background: #004896;
          border-radius: 3px;
        }
      }
    }

    .cards-container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 24px;

      .card {
        height: 424px;
        border-radius: 8px;
        background: white;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 20px;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        border: 1px solid #ebeef5;
        justify-content: space-evenly;
        flex-direction: column;
        color: #333;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
          color: #FF9338;
          .card-heng {
            border: 2px solid #FF9338;
          }
        }

        .card-image {
          width: 78px;
          height: 80px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s;
          }
        }

        .card-heng {
          width: 32px;
          height: 1px;
          border: 2px solid #004896;
        }

        .card-heng:hover {
          border: 3px solid #FF9338;
        }

        .card-jia {
          width: 40px;
          height: 40px;
        }

      //   &:hover .card-image img {
      //     transform: scale(1.05);
      //   }

        .card-content {
          font-size: 18px;
          font-weight: 600;
          z-index: 1;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .container {
    width: 95%;

    .content .cards-container {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

@media (max-width: 768px) {
  .container .content .cards-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .container .content .cards-container {
    grid-template-columns: 1fr;
  }
}
</style>